import { REDUCE_PRODUCT_QTY } from '../../types';

const reduceProductQty = (ids) => (dispatch) => {
  dispatch({ type: REDUCE_PRODUCT_QTY, ids });
};

export { reduceProductQty };
